module.exports = __webpack_public_path__ + "img/shield_fail.31b24df9.svg";